import { IOrderBy } from "../../../../Global/Base/DataSources/Interfaces";
import { IDataGrid } from "../../IDataGrid";
import { Column } from "../Columns/Column";
import { IDataRowElement } from "./IDataRow";
/**
 * Základní rozhraní pro HeaderRow, který nepředpokládá nic o svém rozložení ani způsobu zobrazení dat
 * @includeToDoc
 */
export interface IHeaderRow<R extends IDataRowElement> {
    /**
     * Vytvoří hlavičku komponenty
     * @param owner Datagrid, kterému tyto hlavičky patří
     * @param columns Seznam sloupců
     * @param orderBy Řazení sloupců
     */
    render(owner: IDataGrid<R>, columns: Array<Column>, orderBy: IOrderBy[]): void;
}

// eslint-disable-next-line unused-imports/no-unused-vars
export abstract class IHeaderRow<R extends IDataRowElement> {
    private static _properties: string[] = [];
    private static _methods = ["render"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}

export interface IOpenFormMenuEvent extends CustomEvent {
    detail: MouseEvent;
}
